import Reveal from "@/components/base/Reveal";
import SectionLabel from "@/components/base/SectionLabel";

export default function InternationalSection() {
  return (
    <section className="relative overflow-hidden bg-primary-950 py-20 md:py-24">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="animate-ocean-drift absolute -right-32 -top-24 h-[420px] w-[420px] rounded-full bg-secondary-700/25 blur-3xl" />
        <div className="absolute -bottom-32 -left-24 h-[360px] w-[360px] rounded-full bg-primary-800/40 blur-3xl" />
      </div>

      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute left-0 right-0 top-[30%] h-px bg-gradient-to-r from-transparent via-accent-400/20 to-transparent" />
        <div className="absolute left-0 right-0 top-[52%] h-px bg-gradient-to-r from-transparent via-accent-400/12 to-transparent" />
        <div className="absolute left-0 right-0 top-[74%] h-px bg-gradient-to-r from-transparent via-accent-400/10 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-[1440px] px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20">
          <Reveal>
            <SectionLabel tone="dark">Atuação internacional</SectionLabel>
            <h2 className="mt-5 max-w-2xl font-heading text-3xl font-medium leading-[1.15] text-background-50 md:text-5xl">
              Produtos de origem internacional para o mercado brasileiro.
            </h2>
            <p className="mt-7 max-w-xl text-sm leading-relaxed text-background-100/75 md:text-base">
              A Ocean trabalha com produtos selecionados no mercado internacional, direcionados às necessidades e
              oportunidades identificadas no mercado nacional.
            </p>

            <div className="mt-10 grid grid-cols-1 gap-x-10 gap-y-6 sm:grid-cols-2">
              <div className="border-l border-accent-400/40 pl-5">
                <p className="ocean-label text-[10px] text-accent-300/80">Origem</p>
                <p className="mt-2 text-sm text-background-100/80">Seleção no mercado internacional</p>
              </div>
              <div className="border-l border-accent-400/40 pl-5">
                <p className="ocean-label text-[10px] text-accent-300/80">Destino</p>
                <p className="mt-2 text-sm text-background-100/80">Comercialização em todo o Brasil</p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={140}>
            <div className="relative aspect-[4/3] w-full overflow-hidden rounded-lg border border-accent-400/15">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20stylized%20aerial%20view%20of%20deep%20navy%20ocean%20currents%20and%20shipping%20routes%20with%20fine%20golden%20lines%2C%20minimal%20artistic%20cartography%20style%2C%20dark%20blue%20gradient%20water%2C%20elegant%20premium%20corporate%20imagery%2C%20high%20detail&width=1200&height=900&seq=ocean-international-routes&orientation=landscape"
                alt="Composição abstrata representando rotas marítimas internacionais"
                title="Conexões de comércio internacional"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}